import { MutationTree } from 'vuex';
import { Note, NoteSort, NoteState } from './types';
import dayjs from 'dayjs';

const mutations: MutationTree<NoteState> = {
  open(state, dispatch) {
    state.visible = true;
  },
  close(state) {
    state.visible = false;
  },
  setEditExample(state, example: boolean) {
    state.currentEditExample = example;
  },
  setTotalCount(state, count: number) {
    state.totalCount = count;
  },
  setEndCursor(state, currentPage: string) {
    state.endCursor = currentPage;
  },
  setSort(state, sort: NoteSort) {
    state.sort = sort;
  },
  setNoteList(state, noteList: Array<Note>) {
    // 格式化时间
    state.noteList = noteList.map((note) => {
      try {
        note.updatedAt = dayjs(note.updatedAt).format('YYYY/MM/DD HH:mm:ss');
      } catch (error) {}
      return note;
    });
  },
  updateNoteList(state, noteList: Array<Note>) {
    // 格式化时间
    const formatNoteList = noteList.map((note) => {
      try {
        note.updatedAt = dayjs(note.updatedAt).format('YYYY/MM/DD HH:mm:ss');
      } catch (error) {}
      return note;
    });
    state.noteList = [...state.noteList, ...formatNoteList];
  },
  setHasNext(state, hasNext: boolean) {
    state.hasNext = hasNext;
  },
  setScrollTop(state, scrollTop: boolean) {
    state.scrollTop = scrollTop;
  },
  deleteNote(state, id: string) {
    state.noteList = state.noteList.filter((note) => note.id !== id);
    state.totalCount -= 1;
  }
};

export default mutations;
